import { jsx as _jsx } from 'react/jsx-runtime.js';
import { FlexColumn, FlexGrid } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../hooks/redux/index.js';
import { isFacebookEnabledSelector, isGoogleEnabledSelector, } from '../../../core/siteConfig/siteConfigSlice.js';
import { useOptimizelyExperiment } from '../../../features/optimizely/useOptimizelyExperiment.js';
import { AppleLoginExperimentKey } from '../../../features/optimizely/allExperiments/appleLogin.js';
import { AppleButton } from '../../../features/loginWithApple/index.js';
import { GoogleButton } from '../GoogleButton/index.js';
import { FacebookButton } from '../FacebookButton/index.js';
export const SocialsWrapperDynamic = () => {
    const { t } = useTranslation();
    const isAppleExperimentEnabled = useOptimizelyExperiment(AppleLoginExperimentKey) === 'B';
    // after cleaning the test we should use isAppleEnabledSelector to display the Apple button
    // also the brands.tsx update is required to set socialButtons.apple to true for the brands that support Apple login
    const shouldShowAppleButton = isAppleExperimentEnabled;
    const shouldShowGoogleButton = useAppSelector(isGoogleEnabledSelector);
    const shouldShowFacebookButton = useAppSelector(isFacebookEnabledSelector);
    const children = [
        shouldShowGoogleButton && (_jsx(GoogleButton, { buttonText: t('loginregistration.twoStepLoginRegistration.socialButtons.google') }, 'google')),
        shouldShowAppleButton && _jsx(AppleButton, {}, 'apple'),
        shouldShowFacebookButton && (_jsx(FacebookButton, { buttonText: t('loginregistration.twoStepLoginRegistration.socialButtons.facebook') }, 'facebook')),
    ];
    const MIN_BUTTON_WIDTH = 156;
    const calculateSpan = (count) => {
        const arr = [[12], [12, 12, 6, 6], [12, 12, 12, 4], [12, 12, 6, 6]];
        return arr?.[count - 1] || [12];
    };
    const verifiedChildren = children.filter((child) => !!child);
    const count = verifiedChildren.length;
    return (_jsx(FlexGrid, { gutter: 'spaceM', flxDirection: ['column', 'row'], children: verifiedChildren.map((child) => (_jsx(FlexColumn, { span: calculateSpan(count), sx: { minWidth: `${MIN_BUTTON_WIDTH}px` }, children: child }, child.key))) }));
};
//# sourceMappingURL=SocialsWrapperDynamic.js.map